import { safeGet } from '@mo/mo-safe-request';
import { BASE_PATH } from './routes';

export interface Config {
    registrationUrl: string;
    pingAccessUrl: string;
}

export default async function getConfig(): Promise<Config> {
    return safeGet(`${BASE_PATH}/config`);
}
